import { StateUtils } from '@spartacus/core';
import { CATALOG_ROOT_NODE_ID } from '../catalog-state';

export const LOAD_CATALOG_ROOT_NODE_ID = '[Catalog] Catalog Root Node Id Load';
export const LOAD_CATALOG_ROOT_NODE_ID_SUCCESS = '[Catalog] Catalog Root Node Id Load Success';
export const LOAD_CATALOG_ROOT_NODE_ID_FAIL = '[Catalog] Catalog Root Node Id Load Fail';

export class CatalogRootNodeIdLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_CATALOG_ROOT_NODE_ID;

  constructor() {
    super(CATALOG_ROOT_NODE_ID);
  }
}

export class CatalogRootNodeIdLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_CATALOG_ROOT_NODE_ID_FAIL;

  constructor(public payload: any) {
    super(CATALOG_ROOT_NODE_ID, payload);
  }
}

export class CatalogRootNodeIdLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_CATALOG_ROOT_NODE_ID_SUCCESS;

  constructor(public payload: string) {
    super(CATALOG_ROOT_NODE_ID);
  }
}

export type CatalogRootNodeIdLoadAction =
  | CatalogRootNodeIdLoad
  | CatalogRootNodeIdLoadFail
  | CatalogRootNodeIdLoadSuccess;
